import { getIndustrialProcessWording } from "#shared/helpers/getIndustrialProcessWording";
import {
  IndustrialProcessSchema,
  IndustrialProcessType,
  SurfaceTreatmentMethodSchema,
  SurfaceTreatmentMethodType,
  SurfaceTreatmentTypeType,
} from "shared";

import type { TFunction } from "i18next";

// Not user-selectable "procédés" in the onboarding table: MATERIAL/PRODUCTS/TRANSPORT are
// system-computed process steps, SIMPLE isn't a real industrial process.
const NON_SELECTABLE_PROCESSES: IndustrialProcessType[] = [
  "MATERIAL",
  "PRODUCTS",
  "SIMPLE",
  "TRANSPORT",
];

export const processStepIndustrialProcessOptions = () =>
  IndustrialProcessSchema.options
    .filter((process) => !NON_SELECTABLE_PROCESSES.includes(process))
    .map((process) => ({ value: process, label: getIndustrialProcessWording(process) }))
    .sort((a, b) => a.label.localeCompare(b.label));

const getProcessStepTypeLabel = (t: TFunction, type: SurfaceTreatmentTypeType): string =>
  t(`onboardingV2.processStepConfiguration.typeLabels.${type}`);

export const processStepTypeOptions = (t: TFunction) =>
  (["INHOUSE", "OUTSOURCING"] as const).map((type) => ({
    value: type,
    label: getProcessStepTypeLabel(t, type),
  }));

// "formula" is a valid SurfaceTreatmentMethod but isn't offered as an Unité de prix option here.
const getProcessStepMethodLabel = (t: TFunction, method: SurfaceTreatmentMethodType): string =>
  t(`onboardingV2.processStepConfiguration.methodLabels.${method}`);

export const processStepMethodOptions = (t: TFunction) =>
  SurfaceTreatmentMethodSchema.options
    .filter((method) => method !== "formula")
    .map((method) => ({ value: method, label: getProcessStepMethodLabel(t, method) }));
